import { render } from "./SocialPosts.vue?vue&type=template&id=0e625320&scoped=true"
import script from "./SocialPosts.vue?vue&type=script&lang=js"
export * from "./SocialPosts.vue?vue&type=script&lang=js"

import "./SocialPosts.vue?vue&type=style&index=0&id=0e625320&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e625320"]])

export default __exports__